import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/eye-background-blue.svg'


const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px"}
}
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Masukkan informasi masa berlaku dan trayek yang telah disepakati dalam kontrak", -1)
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "grid grid-cols-2" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "required" }, "Tanggal Mulai Kontrak", -1)
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "required" }, "Tanggal Akhir Kontrak", -1)
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "required" }, "Informasi Trayek"),
  /*#__PURE__*/_createElementVNode("p", null, "Pastikan trayek yang ditambahkan sesuai dengan ketentuan kontrak dengan partner")
], -1)
const _hoisted_14 = { class: "flex items-center gap-2 mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "required" }, "Jenis Trayek", -1)
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "my-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 border-bottom-grey-4-dashed pb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-2/5" }, "TRAYEK"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/5" }, "KELAS"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/5" }, "JENIS PENUMPANG"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 lg:flex justify-center" }, "AKSI")
], -1)
const _hoisted_21 = { class: "flex items-center gap-3 py-28px partner-form" }
const _hoisted_22 = { class: "w-2/5" }
const _hoisted_23 = { class: "invalid-feedback" }
const _hoisted_24 = { class: "w-1/5" }
const _hoisted_25 = { class: "w-1/5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lg:flex justify-center gap-2" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "edit",
        class: "cursor-pointer mb-2 lg:mb-0",
        style: {"width":"35px","height":"35px"}
      })
    ])
  ])
], -1)
const _hoisted_27 = { class: "mt-2 mb-300px rounded-xl background-grey-2" }
const _hoisted_28 = { class: "py-17px px-16px flex items-center gap-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Daftar PP dan Nopol Bus", -1)
const _hoisted_30 = { class: "text-base text-green font-bold" }
const _hoisted_31 = {
  key: 0,
  class: "px-16px pb-17px pt-3"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_33 = { class: "text-left break-words text-sm" }
const _hoisted_34 = { class: "text-left break-words text-sm" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "flex items-center justify-end gap-4 mt-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Kembali'), -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Simpan Kontrak'), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Field = _resolveComponent("Field")!
  const _component_SelectFetchCustom = _resolveComponent("SelectFetchCustom")!
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Form = _resolveComponent("Form", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: $setup.onSubmit,
      "initial-values": $setup.initialValues,
      "validation-schema": $setup.schema
    }, {
      default: _withCtx(({ errors, values, setFieldValue, meta }) => [
        _createVNode(_component_Dialog, {
          class: "partner-contract-dialog",
          showHeader: true,
          visible: $setup.showModal,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (($setup.showModal) = $event)),
          breakpoints: { '960px': '75vw', '640px': '90vw' },
          style: { width: '95vw' },
          modal: true,
          contentClass: "wrap-ctn-modal-default"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, _toDisplayString($setup.title) + " Kontrak", 1),
                _hoisted_4
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: "pi pi-times cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeDialog && $setup.closeDialog(...args)))
                })
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_Button, {
                class: "flex gap-2 extra-submit-button",
                outlined: true
              }, {
                default: _withCtx(() => [
                  _hoisted_37
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                type: "submit",
                class: "mb-2 sm:mb-0 flex gap-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", null, [
                    _createVNode(_component_Field, { name: "StartDate" }, {
                      default: _withCtx(({ field, handleChange, handleBlur }) => [
                        _createVNode(_component_DatePicker, _mergeProps(field, {
                          masks: {
                    input: 'DD/MM/YYYY'
                  },
                          maxDate: values.EndDate ? new Date(new Date(values.EndDate).setDate(new Date(values.EndDate).getDate() - 1)) : null
                        }), {
                          default: _withCtx(({ togglePopover }) => [
                            _createVNode(_component_InputText, {
                              id: "start-date",
                              placeholder: "Masukkan tanggal mulai",
                              readonly: true,
                              value: values.StartDate ? `${$setup.moment(values.StartDate.toString()).format('DD/MM/YYYY')}` : values.StartDate,
                              class: _normalizeClass(`input-default`),
                              onClick: togglePopover
                            }, null, 8, ["value", "onClick"])
                          ]),
                          _: 2
                        }, 1040, ["maxDate"])
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(errors.StartDate), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, [
                    _createVNode(_component_Field, { name: "EndDate" }, {
                      default: _withCtx(({ field, handleChange, handleBlur }) => [
                        _createVNode(_component_DatePicker, _mergeProps(field, {
                          masks: {
                    input: 'DD/MM/YYYY'
                  },
                          minDate: new Date(new Date(values.StartDate).setDate(new Date(values.StartDate).getDate() + 1))
                        }), {
                          default: _withCtx(({ togglePopover }) => [
                            _createVNode(_component_InputText, {
                              id: "end-date",
                              placeholder: "Masukkan tanggal akhir",
                              readonly: true,
                              value: values.EndDate ? `${$setup.moment(values.EndDate.toString()).format('DD/MM/YYYY')}` : values.EndDate,
                              class: _normalizeClass(`input-default`),
                              onClick: togglePopover,
                              disabled: !values.StartDate
                            }, null, 8, ["value", "onClick", "disabled"])
                          ]),
                          _: 2
                        }, 1040, ["minDate"])
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(errors.EndDate), 1)
                  ])
                ])
              ]),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", {
                  onClick: ($event: any) => ($setup.onChangeTrayekType(0, setFieldValue)),
                  class: _normalizeClass(["cursor-pointer", $setup.selectedTrayekType === 0 ? 'blue-white-label' : 'default-label'])
                }, "TRAYEK UMUM", 10, _hoisted_16),
                _createElementVNode("div", {
                  onClick: ($event: any) => ($setup.onChangeTrayekType(1, setFieldValue)),
                  class: _normalizeClass(["cursor-pointer", $setup.selectedTrayekType === 1 ? 'blue-white-label' : 'default-label'])
                }, "TRAYEK BANDARA", 10, _hoisted_17)
              ]),
              ($setup.isTrayekOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_Field, { name: "Trayek" }, {
                            default: _withCtx(({ field, handleChange, handleBlur }) => [
                              ($setup.selectedTrayekType === 0)
                                ? (_openBlock(), _createBlock(_component_SelectFetchCustom, _mergeProps({ key: 0 }, field, {
                                    modelValue: field.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = (data) => $setup.getDetail(data)),
                                    inputId: "class-input",
                                    endpoint: "/management/v2/Trayeks",
                                    fieldLabel: (v) => v.Name,
                                    selectable: (v) => v.IsActive === true,
                                    clearable: false,
                                    searchFields: ['name'],
                                    placeholder: `Pilih Trayek`,
                                    classname: 'custom-select-icon',
                                    searchCustom: [['TrayekTypeId', '=', [$setup.selectedTrayekTypeId]]]
                                  }), null, 16, ["modelValue", "fieldLabel", "selectable", "searchCustom"]))
                                : _createCommentVNode("", true),
                              ($setup.selectedTrayekType === 1)
                                ? (_openBlock(), _createBlock(_component_SelectFetchCustom, _mergeProps({ key: 1 }, field, {
                                    modelValue: field.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = (data) => $setup.getDetail(data)),
                                    inputId: "class-input",
                                    endpoint: "/management/v2/Trayeks",
                                    fieldLabel: (v) => v.Name,
                                    selectable: (v) => v.IsActive === true,
                                    clearable: false,
                                    searchFields: ['name'],
                                    placeholder: `Pilih Trayek`,
                                    classname: 'custom-select-icon',
                                    searchCustom: [['TrayekTypeId', '=', [$setup.selectedTrayekTypeId]]]
                                  }), null, 16, ["modelValue", "fieldLabel", "selectable", "searchCustom"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(errors.Trayek), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(values.Trayek?.MsClassName), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_Field, { name: "Passenger" }, {
                            default: _withCtx(({ field, handleChange, handleBlur }) => [
                              _createVNode(_component_SelectFetch, _mergeProps(field, {
                                modelValue: field.value,
                                inputId: "class-input",
                                endpoint: "/management/v1/MsPassenger",
                                fieldLabel: (v) => v.Type,
                                selectable: (v) => v.IsActive === true,
                                clearable: false,
                                searchFields: ['code'],
                                placeholder: `Pilih Jenis Penumpang`,
                                classname: 'custom-select'
                              }), null, 16, ["modelValue", "fieldLabel", "selectable"])
                            ]),
                            _: 1
                          })
                        ]),
                        _hoisted_26
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isDetailOpen = !$setup.isDetailOpen))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(`pi pi-angle-${$setup.isDetailOpen ? 'down' : 'right'}`)
                          }, null, 2)
                        ]),
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, _toDisplayString(`(${$setup.filters.totalRecords} PP)`), 1)
                      ]),
                      ($setup.isDetailOpen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createVNode(_component_DataTable, {
                              value: $setup.dataSourceDetail,
                              class: "trayek-list-detail"
                            }, {
                              empty: _withCtx(() => [
                                _hoisted_32
                              ]),
                              loading: _withCtx(() => [
                                _createVNode(_component_ProgressSpinner, { style: {"width":"70px","height":"70px"} })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  header: "Jam PP",
                                  style: {"width":"150px"}
                                }, {
                                  body: _withCtx(({ data }) => [
                                    _createElementVNode("p", _hoisted_33, _toDisplayString(data?.TrayekSubs[0]?.TrayekSubsDetails[0]?.RitDepartureTime), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Nopol",
                                  style: {"width":"150px"}
                                }, {
                                  body: _withCtx(({ data }) => [
                                    _createElementVNode("p", _hoisted_34, _toDisplayString(data.RegNumber), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  header: "Aktif/Nonaktif",
                                  style: {"width":"150px"}
                                }, {
                                  body: _withCtx(({ data }) => [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createVNode(_component_InputSwitch, {
                                        modelValue: data.IsSelected,
                                        "onUpdate:modelValue": ($event: any) => ((data.IsSelected) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_Paginator, {
                              class: "trayek-pagination",
                              rows: $setup.filters.pageSize,
                              totalRecords: $setup.filters.totalRecords,
                              onOnPage: $setup.onChangePage
                            }, null, 8, ["rows", "totalRecords", "onOnPage"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, _toDisplayString(errors) + " " + _toDisplayString(meta) + " " + _toDisplayString(values), 1)
            ])
          ]),
          _: 2
        }, 1032, ["visible"])
      ]),
      _: 1
    }, 8, ["onSubmit", "initial-values", "validation-schema"])
  ]))
}